import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllAtmServiceProviders } from "../api/getAllAtmServiceProviders";
import { useTranslation } from "react-i18next";

// All your logic is here
export const useAtmServiceProvidersDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetAtmServiceProvider []>([]);
  const getAllAtmServiceProvidersQuery = useGetAllAtmServiceProviders({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getAllAtmServiceProvidersQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getAllAtmServiceProvidersQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getAllAtmServiceProvidersQuery.data ? getAllAtmServiceProvidersQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "ATM Service Provider",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία ATM Service Provider");
        break;
      case "edit":
        title = t("Επεξεργασία ATM Service Provider");
        break
        case "delete":
        title = t("Διαγραφή ATM Service Provider");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=>{
    setSelectedRowsOfTable([]);
    getAllAtmServiceProvidersQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
